<!--首页轮播图（手机端）-->
<template>
    <div class="banner-box">
        <swiper ref="mySwiper" :options="swiperOption">
            <swiper-slide v-for="(item,i) in bananaList" :key="i">
                <img loading="lazy" class="banner-img" :src="filePre+item.label"
                     :alt="bannerTitle" @error="e => e.target.src = defaultImg">
            </swiper-slide>
            <!-- 分页器 -->
            <div slot="pagination" class="swiper-pagination"></div>
        </swiper>

        <!-- 标题层 -->
        <div class="banner-caption">
            <span class="banner-eyebrow">Debai Wood</span>
            <h1 class="banner-title">{{ bannerTitle }}</h1>
            <p class="banner-sub">{{ bannerSub }}</p>
            <button class="banner-cta" @click="goConcat">{{ $t('get_a_quote') }}</button>
        </div>
    </div>
</template>

<script>
import {reqListDict} from "@/api/base/SysDict";
import global from "@/api/global";
import defaultImg from "@/assets/core/no_img.jpg";
export default {
    name: "MobileHomeBanana",
    data() {
        return {
            filePre: global.preview_path_url,
            defaultImg,
            bananaList: [],
            swiperOption: {
                loop: true,
                autoplay: {
                    delay: 3500,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                effect: 'slide'
            }
        }
    },
    created() {
        this.loadBanana();
    },
    computed: {
        // 优先取多语言文案，缺省用英文兜底（后续可在语言包补充 home_banner_title / home_banner_sub）
        bannerTitle() {
            const t = this.$t('home_banner_title');
            return (t && t !== 'home_banner_title') ? t : 'Premium Timber & Plywood';
        },
        bannerSub() {
            const t = this.$t('home_banner_sub');
            return (t && t !== 'home_banner_sub') ? t : 'Trusted global supplier serving 60+ countries';
        }
    },
    methods: {
        async loadBanana() {
            let result = await reqListDict({dictId: 1});
            this.bananaList = result.data;
        },
        goConcat() {
            this.$router.push("/concat");
        }
    }
}
</script>

<style scoped lang="scss">
.banner-box {
    position: relative;
    width: 100%;
    height: 46vh;
    max-height: 380px;
    min-height: 240px;
    overflow: hidden;
    background: #1b4d33;
}
.banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.banner-caption {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 64px 22px 26px;
    background: linear-gradient(to top, rgba(15,40,27,.92) 0%, rgba(15,40,27,.5) 55%, rgba(15,40,27,0) 100%);
    color: #fff;
}
.banner-eyebrow {
    display: inline-block;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: var(--wood);
    margin-bottom: 8px;
}
.banner-title {
    font-size: 26px;
    font-weight: 800;
    line-height: 1.25;
    margin: 0 0 8px;
    text-shadow: 0 2px 8px rgba(0,0,0,.3);
}
.banner-sub {
    font-size: 14px;
    line-height: 1.6;
    margin: 0 0 16px;
    opacity: .9;
    max-width: 320px;
}
.banner-cta {
    display: inline-block;
    background: var(--brand);
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 11px 26px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    transition: background .2s, transform .2s;

    &:active {
        background: var(--brand-dark);
        transform: translateY(1px);
    }
}
</style>

<!-- 非 scoped：覆盖 swiper 分页器圆点（scoped 下深度选择器不稳） -->
<style>
.banner-box .swiper-pagination-bullet {
    background: #fff;
    opacity: .55;
}
.banner-box .swiper-pagination-bullet-active {
    background: var(--wood);
    opacity: 1;
}
/* 钉死 swiper 各层高度，避免不同图高度不一导致切换时遮挡底部 CTA */
.banner-box .swiper-container,
.banner-box .swiper-wrapper,
.banner-box .swiper-slide {
    height: 100%;
}
.banner-box .swiper-slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
</style>
